'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBusy = undefined;

var _AgentStates = require('../../constants/AgentStates');

var _isAgentState = require('./isAgentState');

var isBusy = exports.isBusy = (0, _isAgentState.isAgentState)(_AgentStates.BUSY);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/agent-state/isBusy.js
// module id = 1014
// module chunks = 2 3